import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../../services/global';
import { BaseCrudComponent } from '../../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

declare const google: any;

@Component({
  selector: 'app-liveroute',
  templateUrl: './liveroute.component.html',
  styleUrls: ['./liveroute.component.css']
})
export class LiverouteComponent extends BaseCrudComponent {

  	id:any;
    lat: number = -2.191332;
    lng: number = -79.565221;
    zoom: number = 11;
  	customers:any;
  	showSidebar = false;
  	loadingRequired = false;
  	reception = false;
  	evaluation = false;
  	fields:any;
  	files:any;
  	c_obj:any;

  	currentRate = 3;

  	translations:any;
    momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;

    status:any;
    assigned:any;
    route_obj:any;

    isTracking:any;
    marker_track = "data:image/png;base64,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";
    track_lat:any;
    track_lng:any;

    delivery_states:any;

    notif_refresh_time = 12000;
    notiftimer:any;
    is_sendingpos = false;
    is_sendingmail = false;

    curr_customer:any;
    near_distance = 50;//in meters
    //test
    //near_distance = 9000;//in meters

    offline_key_list = 'LOGI_DRIVER_LIVE';
    offline_key_customers = 'LOGI_DRIVER_CUSTOMERS';
    offline_key_delivery = 'LOGI_DRIVER_DELIVERY';
    offline_date = '';

    branch_marker = Global.branch_marker;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
      ) {
        super(srv, modalService, storage, router);
        this.id = route.snapshot.params.id;

        this.read_url = 'LogisticRoute/GetInProgressList';
        this.create_url = '';
        this.update_url = '';
        this.delete_url = '';
        this.search_fields = [];
        this.loadingRequired = false;
        this.isTracking = false;
        this.delivery_states = [];
        
        let tmp = this.id.split('_');
        this.f_datefrom = tmp[1];
        this.id = tmp[0];
        this.route_obj = {};
        this.curr_customer = {};

        this.srv.offline.subscribe(r => {
            this.isOffline = r;
        });

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
            }
        });

        this.customers = [];
        this.files = [];
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.f_datefrom = this.curr_date;

        this.trackMe();

        super.ngOnInit();

        //activate timer t report position
        var curr = this;
        this.notiftimer = setInterval(function(){ curr.sendPosition(); }, this.notif_refresh_time);

        this.loadingRequired = true;
        this.getDeliveryStates().subscribe(r => {
            this.loadingRequired = false;
            
            if( r != false ){
              let tmp:any;

              r.forEach(x => {
                tmp = [];

                x.details.forEach(d => {
                  tmp.push({
                    id: d.id,
                    name: d.description,
                    sel: false,
                    reject: (x.name == 'RECHAZADOS') ? true : false
                  });
                });

                this.delivery_states.push({
                  id: x.id,
                  label: x.name,
                  items: tmp
                });
              });
            }

            this.getList();
        });

    }

    public getDeliveryStates(){
        var par_url = 'LogisticStateDelivery/All';

        if( this.isOffline ){
          return from(
            this.srv.getOfflineData(this.offline_key_delivery).then(x => {
                if( (x != undefined) && (x.data != undefined) ){
                    return x.data;
                }
                else{
                    return false;
                }
            })
          );
        }

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          this.srv.saveOfflineData(this.offline_key_delivery, mydata.data);
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    clearData(){
        super.clearData();
        this.customers = [];
    }

    resetDeliveryStates(){
        this.delivery_states.forEach(d => {
            d.items.forEach(i => {
                i.sel = false;
            });
        });
    }

    getList(){
        this.clearData();

        if( this.isOffline ){
            this.srv.getOfflineData(this.offline_key_list).then(x => {
                if( x.data != undefined ){
                    this.parseCustomers(x.data);
                }
            });
        }
        else{
            this.loadingList = true;
            this.srv.postCall(this.read_url, {date:this.f_datefrom}).subscribe(x => {
                var data = x.data;
                this.loadingList = false;

                if(x.status){
                    this.srv.saveOfflineData(this.offline_key_list, data);
                    this.parseCustomers(data);
                    this.enableSidebar();
                }
            });
        }
    }

    parseCustomers(data){
        data.forEach(x => {
          if(x.id == this.id){
            this.route_obj = x;

            let i = 0;
            x.destinations.forEach(d => {
              let tmp:any;
              let coords = d.coordinate.split(';');

              if(i == 0){
                this.lat = parseFloat(coords[0]);
                this.lng = parseFloat(coords[1]);
              }

              this.customers.push({
                id: d.id,
                name: d.clientName,
                lat: coords[0],
                lng: coords[1],
                status: '',
                hour: '',
                address: d.recipientAddress,
                city: d.recipientCity,
                phone: d.recipientPhone,
                invoice: d.invoiceNumber,
                guide: d.guideNumber,
                details: d.details,
                comment: d.comment,
                color: '',
                delivered: d.isDelivered,
                notdelivered: d.isNotDelivered,
                progress: d.isInProgress,
                near: d.isNear,
                routexDestinationId: d.routexDestinationId,
                isSubsidiary: d.isSubsidiary
              });

              if( d.isInProgress || d.isNear ){
                  this.curr_customer = this.customers[i];
              }

              i++;
            });
          }
        });
    }

    sendPosition(){
        if( this.is_sendingpos || this.isOffline ){
            //currently sending position or offline
            return false;
        }

        if( (this.track_lat == undefined) || (this.track_lng == undefined) ){
            //no position info
            return false;
        }

        var qst = 'LogisticRoute/SaveLocation';
        var obj = {
            routeId: this.id,
            latitude: this.track_lat,
            longitude: this.track_lng
        };

        this.is_sendingpos = true;
        this.srv.postCall(qst, obj).subscribe(x => {
            this.is_sendingpos = false;

            if(x.status){
                //console.log('position saved');
            }
            else{
                /*console.log('position not saved');
                console.log(x);*/
            }
        });
    }

  	showCustomerDetails(content:any, obj:any){
    		this.reception = false;
    		this.evaluation = false;
    		this.u_obj = obj;
    		this.u_obj['img'] = [];
        this.resetDeliveryStates();

        if( obj.isSubsidiary ){
            //Swal.fire('Arribo Hivimar', '', 'info');
            this.finishRoute(this.route_obj);
            return;
        }

        //check if exists offline data and resume process
        this.fillSavedDestination(obj['id']);

    		this.modalService.open(content, { centered: true, keyboard: false, backdrop: 'static' });
  	}

  	disableSidebar(){
  		this.showSidebar = false;
  	}

  	enableSidebar(){
  		this.showSidebar = true;
  	}

  	public closeModal(content: any) {
        this.modalService.dismissAll(content);
    }

    public showReception(){
        //console.log(this.route_obj);
        if( (this.route_obj.statusName == 'STOP') && (!this.isOffline) ){
            Swal.fire('Debes REANUDAR la ruta', '', 'error');
            return false;
        }

    	  this.reception = true;
    	  this.evaluation = false;
    }

    public showEvaluation(){
        if( !this.validateDelivery() ){
            return false;
        }

      	this.reception = false;
      	this.evaluation = true;
    }

    public hideReception(){
      	this.reception = false;
      	this.evaluation = false;
    }

    handleInputChange(e, obj:any) {
  	    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
  	    var pattern = /image-*/;
  	    var reader = new FileReader();
  	    /*if (!file.type.match(pattern)) {
  	      alert('invalid format');
  	      return;
  	    }*/

  	    //console.log(file);

  	    reader.onload = (_event) => { 
  	      //this.imgURL = reader.result;
  	      let tmp = {src: reader.result, fname: file.name};
  	      obj.img.push(tmp);
  	      /*obj.img[0].src = reader.result;
  	      obj.img[0].fname = file.name;*/
  	    }

  	    reader.readAsDataURL(file);
  	}

  	clearImgPrev(obj:any){
    		obj.src = '';
    		//console.log(obj);
  	}

  	removeImage(rows:any, obj:any){
      	var i = 0;
      	var count = 0;

      	rows.forEach(x => {
      		if( x.fname == obj.fname ){
      			i = count;
      		}

      		count++;
      	});

      	rows.splice(i, 1);
    }

  	trackMe() {
  	    if (navigator.geolocation) {
  	      	this.isTracking = true;
  	      	navigator.geolocation.watchPosition((position) => {
    	        	//console.log(position);
    	        	this.track_lat = position.coords.latitude;
    	        	this.track_lng = position.coords.longitude;

                //console.log(this.curr_customer);

                if( (this.curr_customer != null) && (this.curr_customer != undefined) && (!this.isOffline) ){
                    //calculate distance when not near
                    if( this.curr_customer.progress && (google != undefined) ){
                        let my_pos = new google.maps.LatLng(this.track_lat, this.track_lng);
                        let customer_pos = new google.maps.LatLng(this.curr_customer.lat, this.curr_customer.lng);
                        //console.log(my_pos);
                        //console.log(customer_pos);
                        let dist = google.maps.geometry.spherical.computeDistanceBetween(my_pos, customer_pos);
                        //console.log(dist);

                        if( (dist <= this.near_distance) && !this.is_sendingmail ){
                            //is near to next point
                            this.is_sendingmail = true;

                            this.sendMailToCustomerNear(this.curr_customer.id, this.id).subscribe(r => {
                                this.is_sendingmail = false;
                                console.log('near mail sent');
                                if( r ){
                                    this.curr_customer.progress = false;
                                    this.getList();
                                }
                            });
                        }
                    }
                }

                //let tmp = new google.maps.LatLng(this.track_lat, this.track_lng);
                //var isWithinPolygon = google.maps.geometry.poly.containsLocation(tmp, ev);

  	      	});
  	    } else {
  	       alert("Geolocation is not supported by this browser.");
  	    }
  	}

  	sendToGmapsDirections(lat:any, lng:any){
  		  window.open('https://www.google.com/maps/dir/?api=1&origin='+this.track_lat+','+this.track_lng+'&destination='+lat+','+lng+'&travelmode=driving', '_blank');
  	}

  	saveSignature(blob: Blob) {
  	    // Do something with the blob.
  	    //console.log(blob);
        this.u_obj['Sign'] = blob;
  	}

    clearTimers(){
        clearInterval(this.notiftimer);
    }

    ngOnDestroy(){
        this.clearTimers();
    }

    validateDelivery(){
        let scount = 0;
        let reject_count = 0;

        this.delivery_states.forEach(s => {
            s.items.forEach(d => {
                if( d.sel ){
                    scount++;

                    //check if is rejected to set image upload optional
                    if(d.reject){
                        reject_count++;
                    }
                }
            });
        });

        if( scount == 0 ){
            Swal.fire('Debe seleccionar al menos 1 opción de entrega', '', 'error');
            return false;
        }

        if( (reject_count == 0) && ((this.u_obj.img.length <= 0) || (this.u_obj.img.length > 3)) ){
            Swal.fire('Debe subir de 1 a 3 imágenes', '', 'error');
            return false;
        }
        
        return true;
    }

    registerShipping(content:any){
        let reject_count = 0;
        let tmp = [];

        this.delivery_states.forEach(s => {
            s.items.forEach(d => {
                tmp.push({stateDetailId: d.id, value:d.sel});
                
                if( d.sel && d.reject ){
                    reject_count++;
                }
            });
        });

        if( reject_count == 0 ){
            if( this.currentRate <= 0 ){
                Swal.fire('Calificación debe ser entre 1 y 5', '', 'error');
                return;
            }

            if( (this.u_obj['NameReceptor'] == undefined) || (this.u_obj['NameReceptor'] == '') ){
                Swal.fire('Se requiere nombre de receptor', '', 'error');
                return;
            }

            if( (this.u_obj['IdReceptor'] == undefined) || (this.u_obj['IdReceptor'] == '') ){
                Swal.fire('Se requiere documento de receptor', '', 'error');
                return;
            }

            if( (this.u_obj['Sign'] == undefined) || (this.u_obj['Sign'] == '') ){
                Swal.fire('Se requiere firma de receptor', '', 'error');
                return;
            }
        }
        else{
            //there is a rejected status, all fields are optional
            if( this.currentRate <= 0 ){
                this.currentRate = 0;
            }

            if( (this.u_obj['NameReceptor'] == undefined) || (this.u_obj['NameReceptor'] == '') ){
                this.u_obj['NameReceptor'] = '';
            }

            if( (this.u_obj['IdReceptor'] == undefined) || (this.u_obj['IdReceptor'] == '') ){
                this.u_obj['IdReceptor'] = '';
            }

            if( (this.u_obj['Sign'] == undefined) || (this.u_obj['Sign'] == '') ){
                this.u_obj['Sign'] = '';
            }
        }

        let images = [];
        this.u_obj.img.forEach(i => {
            images.push({image: i.src});
        });

        var to:any;
        to = {};
        to.RouteId = this.route_obj.id;
        to.DestinationId = this.u_obj.id;
        //to.Image = this.u_obj.img[0].src;
        to.HiviLogisticDeliveryLogImages = images;
        to.Score = this.currentRate;
        to.NameReceptor = this.u_obj.NameReceptor;
        to.IdReceptor = this.u_obj.IdReceptor;
        to.Sign = this.u_obj.Sign;
        to.HiviLogisticStatebydestinations = tmp;
        to.Comment = this.u_obj.comment;
        to.routexDestinationId = this.u_obj.routexDestinationId;

        this.saveOfflineDestination();

        if(this.isOffline){
            Swal.fire('Guardado Localmente', '', 'success');
            return;
        }

        var qst = 'LogisticDestination/SaveDeliveryInfo';
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.removeSavedDestination(this.u_obj.id);
                this.u_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire('Entrega registrada', '', 'success');
            }//end success
            else{
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
                //Swal.fire("entro", '', 'success');
            }
        });
    }

    stop(obj:any){
        var qst = 'LogisticRoute/SetToStop';
        //let trans = this.translations;

        if(this.isOffline){
            Swal.fire('Acción No Disponible Modo Offline', '', 'warning');
            return;
        }

        Swal.fire({
            title: 'Parar ruta?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Ok',
            preConfirm: () => {
                this.srv.postCall(qst, {RouteId: obj.id, Stop: true}).subscribe(x => {
                    let msg = 'Ruta parada exitosamente';

                    if(x.status){
                        this.getList();
                        Swal.fire('Exito', msg, 'success');
                    }
                    else{
                        Swal.fire(msg, '', 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

    resume(obj:any){
        var qst = 'LogisticRoute/SetToStop';
        //let trans = this.translations;

        if(this.isOffline){
            Swal.fire('Acción No Disponible Modo Offline', '', 'warning');
            return;
        }

        Swal.fire({
            title: 'Reanudar ruta?',
            text: '',
            icon: 'success',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Ok',
            preConfirm: () => {
                this.srv.postCall(qst, {RouteId: obj.id, Stop: false}).subscribe(x => {
                    let msg = 'Ruta EN PROGRESO ahora!';

                    if(x.status){
                        this.getList();
                        Swal.fire('Exito', msg, 'success');
                    }
                    else{
                        Swal.fire(msg, '', 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

    finishRoute(obj:any){
        var qst = 'LogisticRoute/SetFinished';

        if(this.isOffline){
            Swal.fire('Acción No Disponible Modo Offline', '', 'warning');
            return;
        }

        Swal.fire({
            title: 'Finalizar ruta?',
            text: '',
            icon: 'question',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Ok',
            preConfirm: () => {
                this.srv.postCall(qst, {id: obj.id}).subscribe(x => {
                    let msg = '';

                    if(x.status){
                        msg = 'Ruta finalizada exitosamente';
                        this.getList();
                        Swal.fire('Exito', x.message, 'success');
                    }
                    else{
                        msg = 'Error al finalizar ruta';
                        Swal.fire('Error', x.message, 'error');
                    }
                });
            }
        }).then((result) => {
        });
    }

    public sendMailToCustomerNear(destination_id:number, route_id:number){
        var par_url = 'LogisticDestination/SendMail';
        var to = {
            _idDestination: destination_id,
            _idRoute: route_id,
            StatusText: 'ISNEAR'
        };

        return this.srv.postCall(par_url, to).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          //return of(mydata.data);
                          return of(true);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public saveOfflineDestination(){
        let rs:any;
        let states = this.delivery_states;
        let rate = this.currentRate;
        let obj = this.u_obj;

        this.srv.getOfflineData(this.offline_key_customers).then(x => {
            if( (x != undefined) && (x.data != undefined) ){
                rs = x.data;
            }
            else{
                rs = {};
            }

            rs[obj.id+'x'] = {states: states, rate: rate, obj: obj};
            this.srv.saveOfflineData(this.offline_key_customers, rs);
        });
    }

    public fillSavedDestination(id:any){
        this.srv.getOfflineData(this.offline_key_customers).then(x => {
            let key = id + 'x';
            
            if( (x != undefined) && (x.data != undefined) && (x.data[key] != undefined) ){
                this.delivery_states = x.data[key]['states'];
                this.currentRate = x.data[key]['rate'];
                this.u_obj = x.data[key]['obj'];
            }
            //console.log(this.u_obj);
        });
    }

    public removeSavedDestination(id:any){
        this.srv.getOfflineData(this.offline_key_customers).then(x => {
            let key = id + 'x';
            
            if( (x != undefined) && (x.data != undefined) && (x.data[key] != undefined) ){
                //delete x.data[key];
                x.data[key] = undefined;
                this.srv.saveOfflineData(this.offline_key_customers, x.data);
            }
        });
    }

}
